import React, { useEffect, useState } from 'react';
import { api } from '../../../../redux/setupAxios';
import { useHistory } from "react-router-dom";

export const EnableSquaddedAlert = ({ merchant }) => {
    const [merchantId, setMerchantId] = useState('');
    const [embedBlockStatus, setEmbedBlockStatus] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            const resData = await api.get('shopify/extension-status');
            setEmbedBlockStatus(!resData.data.status);
            setMerchantId(merchant.merchantId);
        };
        fetchData();
    }, [merchant]);

    const history = useHistory();

    const link = `https://${merchantId}/admin/themes/current/editor?context=apps&activateAppId=fd345b4a-c488-424e-8566-00c66a08a2d2/squadded`;
    return (
        <>
            {embedBlockStatus && (
                <div className="alert alert-custom alert-light-danger fade show mb-5" role="alert">
                    <div className="alert-text"> Currently Extension is disabled please
                        <button type="button" onClick={() => window.open(link)} className="ml-5 btn btn-danger">
                            Enable
                        </button>
                        <button type="button" onClick={() => history.push('/help')} className="ml-5 btn btn-success">
                            Shopify Activation
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}
